module.exports = __webpack_public_path__ + "img/login_box.4313d79b.png";